const constants = {
	primary: process.env.REACT_APP_COLOR,
};

export default constants;

export const listBetType = [
	{
		title: "Toto Ordinary",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/totobanner.jpg",
			},
		],
		digits: 6,
		price: 1,
		hasRoll: 0,
		columns: 2,
	},
	{
		title: "Toto System 7",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/totobanner.jpg",
			},
		],
		digits: 7,
		price: 7,
		hasRoll: 0,
		columns: 2,
	},
	{
		title: "Toto System 8",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/totobanner.jpg",
			},
		],
		digits: 8,
		price: 28,
		hasRoll: 0,
		columns: 2,
	},
	{
		title: "Toto System 9",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/totobanner.jpg",
			},
		],
		digits: 9,
		price: 84,
		hasRoll: 0,
		columns: 2,
	},
	{
		title: "Toto System 10",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/totobanner.jpg",
			},
		],
		digits: 10,
		price: 210,
		hasRoll: 0,
		columns: 2,
	},
	{
		title: "Toto System 11",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/totobanner.jpg",
			},
		],
		digits: 11,
		price: 462,
		hasRoll: 0,
		columns: 2,
	},
	{
		title: "Toto System 12",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/totobanner.jpg",
			},
		],
		digits: 12,
		price: 924,
		hasRoll: 0,
		columns: 2,
	},
	{
		title: "Toto System Roll",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/totobanner.jpg",
			},
		],
		digits: 5,
		hasRoll: 1,
		price: 44,
		columns: 2,
	},
	{
		title: "Fatcat Match 2",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/livetotobanner.jpg",
			},
		],
		digits: 2,
		hasRoll: 0,
		price: 2,
		columns: 6,
	},
	{
		title: "Fatcat Match 3",
		msg: [
			{
				type: "image",
				value: "https://apimadeeasy.com/uploads/livetotobanner.jpg",
			},
		],
		digits: 3,
		hasRoll: 0,
		price: 2,
		columns: 4,
	},
];
